import React from 'react';
import {atom} from 'jotai';

export const loginStepAtom = atom<number>(0);
